import { getRouteComponents } from 'ha/helpers/routes';

import {
  onEnterMy,
  onEnterLangIndex,
  onEnterDefault,
  getIndexRouteWildcard,
  onEnterWildcard,
  onEnterSearhPage,
  getIndexRouteSearchPage,
  getIndexRouteLang,
  getChildRoutesLang,
  getCityCountry,
  onEnterPayoutMethods,
  redirectedRoutes,
  onEnterUserProfile,
  onEnterRoomPage,
} from './utils/routes';
import AppRoot from './components/AppRoot';

export default function getRoutes(store, urlResolver) {
  const getComponents = getRouteComponents(__SERVER__)(store);

  const routes = [
    ...redirectedRoutes,
    {
      path: 'login',
      getComponents: getComponents('Login'),
    },
    {
      path: 'register',
      getComponents: getComponents('Register'),
    },
    {
      path: 's/:location(/)(:localizedKind)',
      onEnter: onEnterSearhPage(store),
      getIndexRoute: getIndexRouteSearchPage(store, getComponents),
    },
    {
      path: 'room/:id/:countryCode/:city(/)*',
      getComponents: getComponents('Listing'),
    },
    {
      path: 'reset-password/:token',
      getComponents: getComponents('ResetPassword'),
    },
    {
      path: 'partner',
      getComponents: getComponents('PartnerDashboard'),
    },
    {
      path: 'users/show/:id',
      getComponents: getComponents('UserPage'),
    },
    {
      path: 'activate-account/:token',
      getComponents: getComponents('ActivateAccount'),
    },
    {
      path: 'answers',
      getComponents: getComponents('Answers'),
    },
    {
      path: 'adyenPaymentResult',
      getComponents: getComponents('AdyenPaymentResult'),
      onEnter: onEnterMy(store),
    },
    {
      path: 'contact',
      getComponents: getComponents('Contact'),
    },
    {
      path: 'cookie-policy',
      getComponents: getComponents('CookiePolicy'),
    },
    {
      path: 'data-security',
      getComponents: getComponents('DataSecurity'),
    },
    {
      path: 'legal',
      getComponents: getComponents('Legal'),
    },
    {
      path: 'list-your-place',
      getComponents: getComponents('ListYourPlace'),
    },
    {
      path: 'partner-redirect',
      getComponents: getComponents('PartnerRedirect'),
    },
    {
      path: 'press-releases',
      getComponents: getComponents('PressReleases'),
    },
    {
      path: 'recover-account',
      getComponents: getComponents('RecoverAccount'),
    },
    {
      path: 'safe-payment-service',
      getComponents: getComponents('SafePaymentService'),
    },
    {
      path: 'sms-accept/:token',
      getComponents: getComponents('SmsAccept'),
    },
    {
      path: 'terms',
      getComponents: getComponents('Terms'),
    },
    {
      path: 'universities',
      getComponents: getComponents('Universities'),
    },
    {
      path: 'university-plans',
      getComponents: getComponents('UniversityPlans'),
    },
    {
      path: 'sitemap',
      getComponents: getComponents('Sitemap'),
    },
    {
      path: 'under-review',
      getComponents: getComponents('UnderReview'),
    },
    {
      path: 'auth/facebook/callback',
      getComponents: getComponents('FacebookLogin'),
    },
    {
      path: 'auth/google/callback',
      getComponents: getComponents('GoogleLogin'),
    },
    {
      path: 'h/:token',
      getComponents: getComponents('Shortlink'),
    },
    {
      path: 'my',
      indexRoute: {
        getComponents: getComponents('UserDashboard'),
      },
      onEnter: onEnterMy(store),
      childRoutes: [
        {
          path: 'inbox',
          getComponents: getComponents('Inbox'),
        },
        {
          path: 'bookings',
          getComponents: getComponents('Reservations'),
        },
        {
          path: 'listings',
          getComponents: getComponents('Listings'),
        },
        {
          path: 'listings/:id/edit',
          getComponents: getComponents('ListingEdit'),
        },
        {
          path: 'listings/:id/calendar',
          getComponents: getComponents('ListingCalendar'),
        },
        {
          path: 'upload/:id',
          getComponents: getComponents('ListingUploadImages'),
        },
        {
          path: 'profile/edit',
          getComponents: getComponents('ProfileEdit'),
        },
        {
          path: 'talk/:id',
          getComponents: getComponents('Talk'),
        },
        {
          path: 'talk/:id/:mode',
          getComponents: getComponents('Booking'),
        },
        {
          path: 'get-verified',
          getComponents: getComponents('Verification'),
        },
        {
          path: 'verify-phone-number',
          getComponents: getComponents('VerifyPhoneNumber'),
        },
        {
          path: 'share-room/:id',
          getComponents: getComponents('ShareRoom'),
        },
        {
          path: 'favorites',
          getComponents: getComponents('FavoriteListings'),
        },
        {
          path: 'subscriptions',
          getComponents: getComponents('Subscriptions'),
        },
        {
          path: 'subscriptions/search-alerts/:id/unsubscribe',
          getComponents: getComponents('SearchAlertsUnsubscribe'),
        },
        {
          path: 'payment-requests',
          getComponents: getComponents('PaymentRequests'),
        },
        {
          path: 'profile/:userID/confirm/:token',
          getComponents: getComponents('ConfirmProfile'),
        },
        {
          path: 'profile/:userID/pm/confirm/:token',
          getComponents: getComponents('ConfirmPayoutMethod'),
        },
        {
          path: 'profile/:userID',
          onEnter: onEnterUserProfile,
        },
        {
          path: 'callback/create-search-alert',
          getComponents: getComponents('ConfirmSearchAlert'),
        },
        {
          path: 'payout-methods',
          onEnter: onEnterPayoutMethods(urlResolver),
        },
        {
          path: 'payments',
          indexRoute: {
            getComponents: getComponents('PaymentMethods'),
          },
          childRoutes: [
            {
              path: 'methods',
              getComponents: getComponents('PaymentMethods'),
            },
            {
              getComponents: getComponents('PaymentsPaymentRequests'),
              path: 'requests',
            },
          ],
        },
        {
          path: 'payouts',
          indexRoute: {
            getComponents: getComponents('PayoutsPreferences'),
          },
          childRoutes: [
            {
              path: 'preferences',
              getComponents: getComponents('PayoutsPreferences'),
            },
            {
              path: 'history',
              getComponents: getComponents('PayoutsHistory'),
            },
            {
              path: 'invoices',
              getComponents: getComponents('PayoutsInvoices'),
            },
            {
              path: 'plan',
              getComponents: getComponents('PayoutsPlan'),
            },
            {
              path: 'billing',
              getComponents: getComponents('PayoutsBilling'),
            },
            {
              path: 'payment-requests',
              getComponents: getComponents('PayoutsPaymentRequests'),
            },
          ],
        },
      ],
    },
    {
      path: ':city--:country',
      getComponents: getCityCountry(store, getComponents),
    },
    {
      path: 'r/pay/:handle',
      getComponents: getComponents('PayPaymentRequest'),
    },
    {
      path: 'r/*',
      onEnter: onEnterRoomPage,
    },
  ].map(route => ({ ...route, onEnter: route.onEnter || onEnterDefault }));

  return {
    path: '/',
    component: AppRoot,
    indexRoute: {
      getComponents: getComponents('Home'),
    },
    childRoutes: [
      ...routes,
      {
        path: ':lang/',
        onEnter: onEnterLangIndex,
        getIndexRoute: getIndexRouteLang(getComponents, 'Home'),
        getChildRoutes: getChildRoutesLang(routes),
      },
      {
        path: '*',
        onEnter: onEnterWildcard,
        // react-router calls the callback provided to `getIndexRoute` twice
        // when it returns a promise
        // @link http://goo.gl/6gT7Y8
        getIndexRoute: getIndexRouteWildcard(store, getComponents),
      },
    ],
  };
}
